import toast from 'react-hot-toast';

export const notification = ({text = '', type = 'success'}) => {
  let style = {
    borderRadius: '10px',
    background: '#333',
    color: '#FFF',
    padding: '8px 12px'
  };

  let options = {
    duration: 6000,
    position: 'top-center',
    style: style,
  };

  if(type === 'success') { return toast.success(text, options) }
  if(type === 'error') { return toast.error(text, options) }
}